

import LayoutMain from '@/layout';
import setting from '@/setting';
let routePre = setting.routePre;

const meta = {
  auth: true,
};

const pre = 'company_';

export default {
  path: routePre + '/company',
  name: 'company',
  header: 'company',
  redirect: {
    name: `${pre}index`,
  },
  component: LayoutMain,
  children: [
	
	
	
	
	{
	  path: 'index',
	  name: `${pre}index`,
	  meta: {
	    //auth: ['company-company'],
	    title: '组织管理',
	  },
	  component: () => import('@/pages/company/company'),
	},
	
	{
	  path: 'add',
	  name: `${pre}add`,
	  meta: {
	    //auth: ['company-company'],
	    title: '添加组织',
		activeMenu: routePre + '/company/index',
	  },
	  component: () => import('@/pages/company/company/add'),
	},
	
	{
	  path: 'admin',
	  name: `${pre}admin`,
	  meta: {
	    //auth: ['company-company'],
	    title: '组织账号',
	  },
	  component: () => import('@/pages/company/admin'),
	},
	
	
	{
	  path: 'role',
	  name: `${pre}role`,
	  meta: {
	    //auth: ['setting-auth-admin'],
	    title: '角色管理',
	  },
	  component: () => import('@/pages/company/role'),
	},
	
	{
	  path: 'menus',
	  name: `${pre}menus`,
	  meta: {
	    //auth: ['setting-auth-menus'],
	    title: '功能菜单',
	  },
	  component: () => import('@/pages/company/menus'),
	},
	
  ],
};
